import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

export function save(listing) {
  const body = {
    ...listing,
    quickUpdate: true,
    voucherAttributes: {
      commissionEstimates: listing.voucher.commissionEstimates,
      grossCommissionAmount: listing.voucher.grossCommissionAmount,
      grossCommissionPercent: listing.voucher.grossCommissionPercent,
      transactionValue: listing.voucher.transactionValue,
    }
  };

  delete body.selectedProperty;
  delete body.voucher;

  if (listing.selectedProperty) {
    if (listing.selectedProperty.id) {
      body.selectedPropertyId = listing.selectedProperty.id;
    } else {
      body.selectedPropertyAttributes = listing.selectedProperty;
    }
  }

  const fullBody = { listing: body };
  if (listing.renewalReminder) {
    fullBody.expirationCount = listing.renewalReminder.expirationCount;
    fullBody.expirationUnit = listing.renewalReminder.expirationUnit;
    fullBody.sendExpirationReminder = !!(fullBody.expirationCount && fullBody.expirationUnit);
    delete body.renewalReminder;
  }

  return axios.put(`${listing.path}.json`, snakecaseKeys(fullBody))
    .then((response) => {
      return camelcaseKeys(response.data, { deep: true }).listing;
    })
    .catch((error) => {
      throw error.response.data.errors;
    });
}
